/// <amd-module name="SuiteCommerce.GiftCertificate.OptionTiles.Tile.Model"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GiftCertificate.OptionTiles.Tile.Model", ["require", "exports", "SuiteCommerce.GiftCertificate.Common.Utils", "SuiteCommerce.GiftCertificate.Common.DependencyProvider", "SuiteCommerce.GiftCertificate.OptionTiles.Configuration"], function (require, exports, Utils_1, DependencyProvider_1, OptionTiles_Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.TileModel = void 0;
    var TileModel = /** @class */ (function (_super) {
        __extends(TileModel, _super);
        function TileModel() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Object.defineProperty(TileModel.prototype, "giftCertificateGroupId", {
            get: function () {
                return this.get('custitem_ns_sc_ext_gift_cert_group_id');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(TileModel.prototype, "url", {
            get: function () {
                return this.get('urlcomponent') || "/product/".concat(this.internalId);
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(TileModel.prototype, "internalId", {
            get: function () {
                return this.get('internalid');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(TileModel.prototype, "name", {
            get: function () {
                return (this.get('storedisplayname2') ||
                    this.get('displayname') ||
                    this.get('itemid') ||
                    '');
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(TileModel.prototype, "price", {
            get: function () {
                var onlinePriceDetails = this.get('onlinecustomerprice_detail');
                return onlinePriceDetails.onlinecustomerprice;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(TileModel.prototype, "formattedPrice", {
            get: function () {
                var onlinePriceDetails = this.get('onlinecustomerprice_detail');
                return onlinePriceDetails.onlinecustomerprice_formatted;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(TileModel.prototype, "label", {
            get: function () {
                var label = this.get('custitem_ns_sc_ext_options_button_lbl') ||
                    OptionTiles_Configuration_1.OptionTilesConfiguration.giftOptionButtonLabel;
                if (label) {
                    label = label.replace('[[name]]', this.name);
                    if (this.isLoginToSeePriceEnabled()) {
                        label = label.replace('[[price]]', '');
                        label.trim();
                        if (label.length === 0) {
                            label = this.name;
                        }
                    }
                    else {
                        label = label.replace('[[price]]', this.formattedPrice);
                    }
                }
                return label;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(TileModel.prototype, "thumbnail", {
            get: function () {
                if (this.get('itemimages_detail').thumbnail) {
                    return this.get('itemimages_detail').thumbnail;
                }
                return this.thumbnailFromAll();
            },
            enumerable: false,
            configurable: true
        });
        TileModel.prototype.isGiftCertificateItem = function () {
            return this.get('itemtype') === 'GiftCert';
        };
        TileModel.prototype.thumbnailFromAll = function () {
            var flattenedImages;
            var itemImagesDetail = this.get('itemimages_detail');
            itemImagesDetail = itemImagesDetail.media || itemImagesDetail;
            flattenedImages = Utils_1.Utils.imageFlatten(itemImagesDetail);
            if (flattenedImages.length) {
                return flattenedImages[0];
            }
            return;
        };
        TileModel.prototype.isLoginToSeePriceEnabled = function () {
            return Utils_1.Utils.hidePrices();
        };
        return TileModel;
    }(DependencyProvider_1.BackboneCachedModel));
    exports.TileModel = TileModel;
});
